import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	assignAttendanceIcon: {
		transform: "scaleX(-1)"
	},
	filterInput: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		"& fieldset": {
			borderRadius: 3
		}
	},
	textareaLineNumbers: {
		"& > div": {
			paddingLeft: theme.spacing(2),
			paddingRight: theme.spacing(2)
		}
	}
}))

export default useStyles
